import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react"

interface Props {
    isOpen: boolean,
    onClose: any
}

const FinishEvent = ({ isOpen, onClose }: Props) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Finalizar agendamento</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    Confirme a finalização do evento
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button variant="ghost" onClick={onClose}>Cancelar</Button>
                        <Button colorScheme="green" onClick={onClose}>Finalizar</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default FinishEvent
